import styles from "../../assets/scss/modules/PublicListingSingle.module.scss";
import React from 'react';
import {useWpContext} from "../context/WordPressProvider.tsx";
import {useFetchExpendituresQuery} from "../../store/api-rest.ts";
import {CtrDepenses, CtrDomainsVf, CtrDynamicTables, CtrInscriptions} from "../../graphql/generated/graphql-main.tsx";
import useCtrValeursFixes from "../../hooks/useCtrValeursFixes.ts";
import {useSingleListing} from "../context/SingleListingProvider.tsx";
import useCtrMetaFields from "../../hooks/useCtrMetaFields.tsx";
import useReactTexts from "../../hooks/useReactTexts.ts";

const ListingTabEvalSpend = () => {
    const {others, is_fr} = useWpContext<ZListingSingle>();
    const {__} = useReactTexts();
    const {listing: lst} = useSingleListing();
    const {fixedValue} = useCtrValeursFixes();
    const {toHtml} = useCtrMetaFields();
    const {data} = useFetchExpendituresQuery(others.mls_id);

    const elem = toHtml<CtrInscriptions>(lst, CtrDynamicTables.Inscriptions);

    return <div className={"flex flex-wrap gap-0 md:gap-12"}>

        {/* assessments */}
        <div className={"mb-4"}>
            {/* section title */}
            <div className={styles.subtitle__eval}>
                {__("Évaluations")}
            </div>

            <div className={"space-y-4"}>
                <div>{elem("EVALUATION_MUNICIPALE_BATIMENT", {type: "currency"})}</div>
                <div>{elem("EVALUATION_MUNICIPALE_TERRAIN", {type: "currency"})}</div>
                <div>{elem("ANNEE_EVALUATION")}</div>
                <div>{elem("DATE_REV_BRUT_POT")}</div>
                <div>{elem("DEPENSES_TOT_EXPLOITATION", {type: "currency"})}</div>
                <div>{elem("DEVISE_PRIX_LOCATION_DEMANDE")}</div>
                <div>{elem("EN_OPER_DEPUIS")}</div>
                <div>{elem("FREQUENCE_PRIX_LOCATION", {domain: CtrDomainsVf.FrequencePrixLocation})}</div>
                <div>{elem("IND_FRANCHISE")}</div>
                <div>{elem("IND_OPTION_ACHAT")}</div>
                <div>{elem("IND_VENTE_SANS_GARANTIE_LEGALE", {domain: CtrDomainsVf.IndVenteSansGarantieLegale})}</div>
                <div>{elem("REV_POT_BRUT_AU", {type: "currency"})}</div>
                <div>{elem("REV_POT_BRUT_COMM", {type: "currency"})}</div>
                <div>{elem("REV_POT_BRUT_RES", {type: "currency"})}</div>
                <div>{elem("REV_POT_BRUT_STAT", {type: "currency"})}</div>

                {/* note: irrelevant pieces of data */}
                {/*<div>{elem("ANNEE_MOIS_ECHEANCE_BAIL")}</div>*/}
                {/*<div>{elem("CODE_DECLARATION_VENDEUR", {domain: CtrDomainsVf.CodeDeclarationVendeur})}</div>*/}
                {/*<div>{elem("DATE_FIN_BAIL")}</div>*/}
                {/*<div>{elem("DATE_OCCUPATION")}</div>*/}
                {/*<div>{elem(is_fr ? "DELAI_OCCUPATION_FRANCAIS" : "DELAI_OCCUPATION_ANGLAIS")}</div>*/}
                {/*<div>{elem("IND_ECHANGE_POSSIBLE")}</div>*/}
                {/*<div>{elem("IND_OPT_RENOUV_BAIL")}</div>*/}
                {/*<div>{elem("DATE_MISE_EN_VIGUEUR")}</div>*/}
                {/*<div>{elem("IND_REPRISE_FINANCE")}</div>*/}
                {/*<div>{elem("IND_TAXES_PRIX_DEMANDE")}</div>*/}
                {/*<div>{elem("IND_TAXES_PRIX_LOCATION_DEMANDE")}</div>*/}
                {/*<div>{elem("RAISON_SOCIALE")}</div>*/}
                {/*<div>{elem("DATE_MODIF")}</div>*/}
                {/*<div>{elem("POURC_QUOTE_PART", {type: "percent"})}</div>*/}
            </div>
        </div>

        {/* expenses */}
        <div className={""}>
            <div className={styles.subtitle__eval}>
                {__("Dépenses")}
            </div>

            <div className={"space-y-4"}>
                {data?.map((it: CtrDepenses, idx) => {
                    const elem2 = toHtml<CtrDepenses>(it, CtrDynamicTables.Depenses);

                    // definition list
                    return <dl key={`dep-${it?.NO_INSCRIPTION}.${idx}`} className={""}>
                        {/* definition term */}
                        <dt className={"font-bold"}>
                            {fixedValue(CtrDomainsVf.TypeDepense, it?.TDEP_CODE)}
                            {' - '} {fixedValue(CtrDomainsVf.PartDepense, it?.PART_DEPENSE)}
                        </dt>
                        {/* definition descriptions */}
                        <dd>{elem2("ANNEE", {uniline: true, noDef: true})}</dd>
                        <dd>{elem2("ANNEE_EXPIRATION", {uniline: true, noDef: true})}</dd>
                        <dd>{elem2("MONTANT_DEPENSE", {
                            type: "currency",
                            uniline: true,
                            noDef: true
                        })}</dd>
                        <dd>{elem2("FREQUENCE", {
                            domain: CtrDomainsVf.FrequenceDepense,
                            uniline: true,
                            noDef: true
                        })}</dd>
                        <dd>{elem2(is_fr ? "AU_DEPENSE_INFO_F" : "AU_DEPENSE_INFO_A", {
                            uniline: true,
                            noDef: true
                        })}</dd>
                    </dl>
                })}
            </div>
        </div>
    </div>
};

export default ListingTabEvalSpend;